import React from 'react';
import { Crown, ArrowRight, TrendingUp, Users, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function LeadershipPage() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-925">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-926">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-927" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-928">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-929">
            Executive Recruiting
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-930">
            HIRE Leadership
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-931">
            For companies that need to recruit leadership-level talent to scale
            their D2D and home services operation.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-932">
            Finding managers and team leaders requires a different approach. We
            build and run targeted campaigns to attract the leaders who will
            drive your team's growth.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-933">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-934">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-935">
            <div className="mb-4" data-id="element-936">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-937">
                Build and Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-938">$7,500</div>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-939">
                {['Leadership opportunity and company profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and leadership-focused ad copywriting', 'Landing pages and executive application flows', 'Targeted campaign design built to reach experienced operators', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Covers build and implementation of standard and leadership campaign'].map((point, i) => <li key={i} className="flex items-start" data-id="element-940">
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-941" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-942">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-943">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-944" />
            <div className="mb-4" data-id="element-945">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-946">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-947">$2,500</div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-948">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-949">
                <div className="flex justify-between text-sm" data-id="element-950">
                  <span className="text-slate-400" data-id="element-951">Campaign Management</span>
                  <span className="text-white font-medium" data-id="element-952">$2,500</span>
                </div>
              </div>

              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-953">
                {['Active ad management and real-time optimization', 'Targeted outreach to experienced operators and team leaders', 'Interview execution handled for you', 'Vetted candidates passed to you for final approval only', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-954">
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-955" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-956">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Performance Pricing */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-957">
            <div className="mb-4" data-id="element-958">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-959">
                Performance Pricing
              </div>
              <div className="flex items-baseline mb-2" data-id="element-960">
                <span className="text-3xl font-bold text-white" data-id="element-961">2.5%</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-962">of revenue</span>
              </div>
              <p className="text-sm text-slate-400 mb-4" data-id="element-963">Capped at $15,000</p>
              <div className="bg-slate-900/60 border border-slate-700/50 rounded-lg p-3" data-id="element-964">
                <p className="text-xs text-slate-400 flex items-start leading-relaxed" data-id="element-965">
                  <ArrowRight className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-966" />
                  <span data-id="element-967">
                    Based on the leader's{' '}
                    <strong className="text-slate-200" data-id="element-968">
                      personal and team
                    </strong>{' '}
                    production combined.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-969">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-970">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 3. WHO LEADERSHIP IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-971">
        <div className="text-center mb-12" data-id="element-972">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-973">
            Why Leadership Recruiting Is Different
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-974">
            Recruiting managers and team leaders requires a different approach
            than recruiting reps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-975">
          <div className="space-y-4 text-slate-400" data-id="element-976">
            <p data-id="element-977">
              Leadership-level talent doesn't respond to mass recruiting
              funnels. They aren't looking, so they need to be found.
            </p>
            <p data-id="element-978">
              We build dedicated campaigns designed to attract operators who can
              run teams, drive culture, and own production at scale.
            </p>
            <p data-id="element-979">
              Because the impact of one strong leader compounds, the pricing is
              aligned to outcomes, not activity.
            </p>
          </div>
          <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 space-y-6" data-id="element-980">
            <div className="flex items-start" data-id="element-981">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-982">
                <Users className="w-6 h-6 text-[#7FE0C3]" data-id="element-983" />
              </div>
              <div data-id="element-984">
                <h3 className="text-white font-bold mb-2" data-id="element-985">
                  Interviews Handled
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-986">
                  We run the interview process and only pass candidates to you
                  for final approval, so leadership time stays focused on
                  production.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-987">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-988">
                <TrendingUp className="w-6 h-6 text-[#7FE0C3]" data-id="element-989" />
              </div>
              <div data-id="element-990">
                <h3 className="text-white font-bold mb-2" data-id="element-991">
                  Performance Aligned
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-992">
                  You only pay more when the leader's team actually produces.
                  Performance pricing kicks in at production milestones, not at
                  hire.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-993">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-994">
                <Crown className="w-6 h-6 text-[#7FE0C3]" data-id="element-995" />
              </div>
              <div data-id="element-996">
                <h3 className="text-white font-bold mb-2" data-id="element-997">Targeted Outreach</h3>
                <p className="text-slate-400 text-sm" data-id="element-998">
                  Campaigns are built to attract experienced operators, not
                  generic applicants.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-999">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-1000">
          Ready to recruit leaders who scale your team?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-1001">
          Discuss Leadership
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-1002" />
        </button>
      </section>
    </div>;
}